/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from 'react'
import Box from '@mui/material/Box'
import DtlOriginals from 'src/components/pages/dtlOriginals/DtlOriginals'
import { apiFetch } from '../service/api.service'

interface IProps {
  data: any
}
export default function DtlOriginal({ data }: IProps) {
  return (
    <Box component="div">
      <DtlOriginals data={data} />
    </Box>
  )
}

// This gets called on every request
export async function getServerSideProps() {
  // Fetch data from external API
  const baseURL =
    process.env.NEXT_PUBLIC_BACKEND_URL ||
    'https://strapi-beta.ditchthelabel.org'
  const endPoint =
    process.env.NEXT_PUBLIC_SITE_LANGUAGE === 'en'
      ? `/api/article-schemas?filters[name][$eq]=dtlOriginals&populate=deep`
      : `/api/article-schemas?filters[name][$eq]=mx-dtlOriginals&populate=deep&locale=es-MX`
  const url = baseURL + endPoint

  const data = await apiFetch(url)

  // Pass data to the page via props
  return { props: { data } }
}
